import { useScrollToTop } from "core/hooks/useScrollToTop";
import AppLayout from "core/layouts/AppLayout";
import BottomNavigation from "core/layouts/BottomNavigation";
import CListItemMenu from "core/components/CListItemMenu";
import PageHeader from "core/components/Header/PageHeader";
import { useCustomNavigate } from "core/hooks/useCustomNavigate";
import { route, RouterName } from "core/router";
import { CImagePicker } from "core/components/form-controls";
import CameraIcon from 'core/assets/icons/menu/camera.svg';
import CDialog from "core/components/CDialog";
import { useCallback, useEffect, useState } from "react";
import { _t } from "core/language";
import { useDispatch, useSelector } from "react-redux";
import * as action from "modules/Auth/store/actions";
import { useRecipe } from "modules/Ingredients/hooks/recipe";
import { useUser } from "modules/Auth/hooks";
import API from "core/networks/API";
import { API_UPDATE_AVATAR } from "../api";
import { resetImages } from "core/store/upload/actions";
import { TypeUserLogin } from "core/constants";
import SelectSwiper from "modules/AiChef/components/AddRecipeByImageSwiperButton/SelectSwiper";
import { useGetImagePicker } from "core/hooks/useImagePicker";
import LoginItem from "core/components/LoginItem";
import { useLocation } from "react-router-dom";
import { resetCountCart } from "modules/Carts/store/actions";
import { LOGOUT_SUCCESS } from "modules/Auth/store/types";
import { updateFavoriteListLocal } from "modules/Favorites/store/actions";


const MenuPage = () => {
  const { resetRecipes } = useRecipe()
  const dispatch = useDispatch();
  useScrollToTop()
  const navigate = useCustomNavigate();
  const auth = useSelector((state: any) => state.Auth);
  const {userInfo} = useUser()
  console.log(userInfo,'user',auth)
  const [stateDialogLogout, setStateDialogLogout] = useState(false);
  const [imageUpdate, setImageUpdate] = useState({avatar_uuid:userInfo?.avatar?.uuid});
  const [stateOpenUpload, setStateOpenUpload] = useState(false);
  const [activeLogout, setActiveLogout] = useState(false);
  const imageUploaded = useGetImagePicker(
    'avatar',
    false
  )
  const [stateFileLoading, setStateFileLoading] = useState(false);
  const menuItems = [
    { label: _t('main.favorites'), url: RouterName.FAVORITES, active: auth?.token ? true : false },
    { label: _t('auth.MenuLanguageSettings'), url: RouterName.LANGUAGE_SETTING, active: true },
    { label: _t('auth.MenuNotificationSettings'), url: RouterName.NOTIFICATION_SETTING, active: auth?.token ? true : false },
    { label: _t('auth.MenuPrivacyPolicy'), url: RouterName.PRIVACY_POLICY_APP, active: true },
    { label: _t('auth.MenuLogout'), url: 'LOGOUT', active: auth?.token ? true : false },
    { label: _t('auth.MenuLeaveMembership'), url: RouterName.LEAVE_MEMBERSHIP, active: auth?.token ? true : false },
    { label: _t('auth.LabelSignUp'), url: RouterName.SIGNUP_POLICY+'?backPage='+route(RouterName.MENU), active: auth?.token ? false : true },
  ];
  const location = useLocation();
  console.log(route(RouterName.MENU),'tesst',location)
  const handleClick = (data: any) => {
    localStorage.removeItem('dataPolicy')
    if(data?.url.includes('LOGOUT')){
      setStateDialogLogout(true)
      return
    }
    handleToPage(data?.url)
  }
  
  const handleUpdateAvatar = useCallback(async () => {
    const dataRequest = {
      avatar_uuid: imageUpdate?.avatar_uuid,
    };
    
    try {
      const { data: response } = await API.post(`${API_UPDATE_AVATAR}`, dataRequest);
      if (response && response?.code === 200) {
        dispatch(action.updateInfoUser(response.data));
      }
    } catch (e: any) {
      console.log('error', e);
      
      // Handle error
    }
  }, [imageUpdate?.avatar_uuid, dispatch]);


  useEffect(() => {
    if (auth?.token) {
      dispatch(updateFavoriteListLocal({dataList:[],scrollPosition:0})); // RESTORE FAVORITE LIST
    }
  },[])

  useEffect(() => {
    if(imageUploaded?.uuid && !imageUploaded?.uploading && userInfo?.avatar?.uuid !== imageUploaded?.uuid) {
      setImageUpdate((p) => ({
        ...p,
        avatar_uuid:imageUploaded?.uuid
      }))
    }
  },[imageUploaded])

  useEffect(() => {
    if(imageUpdate?.avatar_uuid && userInfo?.avatar?.uuid !== imageUpdate?.avatar_uuid) {
      handleUpdateAvatar()
    }
  },[imageUpdate?.avatar_uuid, userInfo?.avatar?.uuid, handleUpdateAvatar])


  useEffect(() => {
    if ([LOGOUT_SUCCESS].includes(auth?.type) && activeLogout) {
      dispatch(resetImages())
      dispatch(resetCountCart())
      navigate(RouterName.MAIN)
    }
  }, [auth?.type]);

  const handleUpdateAvt = (data:any) => {
    console.log(data,'handleUpdateAvt',stateOpenUpload)
    setStateOpenUpload(true)
  };
  const handleChoose = (data:any) => {
    console.log(data,'handleChoose',stateOpenUpload)
    setStateOpenUpload(data)
  };

  const handleStateFileLoading = (data:any) => {
    setStateFileLoading(data)
  };

  const handleToPage = (url: any) => {
    navigate(url)
  }

  const handleLogout = () => {
      // @ts-ignore
      window.webviewResponeLanguage({ lang: (window as any)._APP_LANG });
      dispatch(action.logOutRequest((window as any)._APP_LANG));
      setActiveLogout(true)
      if(userInfo?.type && userInfo?.type === TypeUserLogin.SNS) {
        // @ts-ignore
        window.webViewRequestLogout(auth?.token)
      }
  }
  
  return (
    <AppLayout className={"main-page-client  pt-[43px]"}>
      <PageHeader title={_t('auth.Menu')}/>
      <div className="bg-[#f4f4f4]">
        {auth?.token ? <section className="flex gap-5 justify-between px-4 pt-[30px] pb-[24px] w-full bg-white text-neutral-900 mb-2">
          <div  className="flex gap-2 text-sm tracking-tighter leading-loose whitespace-nowrap items-center">
            <div onClick={()=>{setStateOpenUpload(true)}}>
              <div className="pointer-events-none w-[40px] h-[40px] min-w-[40px]">
                {stateFileLoading || userInfo.avatar ? <div></div> : <img src={CameraIcon} alt={'CameraIcon'} />}
                <CImagePicker
                  name="avatar"
                  handleImageChange={handleUpdateAvt}
                  property={'USER'}
                  hideRemoveIcon
                  initData={userInfo.avatar}
                  className="relative"
                  handleStateFileLoading={handleStateFileLoading}
                  component={{
                    input: <div></div>,
                    loading: <div 
                      className="flex 
                      justify-center 
                      items-center 
                      w-[40px] 
                      h-[40px] 
                      dots 
                      border 
                      border-solid 
                      border-1 
                      rounded-full 
                      border-zinc-300
                      absolute
                      top-[0px]
                      bg-white
                      ">
                      <span className="text-[15px] block">.</span>
                      <span className="text-[15px]">.</span>
                      <span className="text-[15px]">.</span>
                    </div>,
                    preview: ({src }: any) => {
                      return <img
                      src={src}
                      alt={userInfo?.name}
                      className="object-cover w-[40px] h-[40px] rounded-full border"
                    />
                    }
                      
                  }}
                />
              </div>
            </div>
            {/* <img loading="lazy" src={imgDefault} alt="" className="object-contain shrink-0 w-10 aspect-square" /> */}
            <div className="my-auto basis-auto text-[13px] font-normal text-[#111111] break-all whitespace-break-spaces" onClick={() => handleToPage(RouterName.CHANGE_DISPLAY_NAME)}>
                <p className="text-[#111111] text-[13px] font-bold">{userInfo?.name}</p>
                <span className="text-[#333333] text-[13px]">{'@'+userInfo?.username} - {userInfo?.email || userInfo?.name}</span>
            </div>
          </div>
          {userInfo?.type && userInfo?.type === TypeUserLogin.NORMAL && <button onClick={()=>handleToPage(RouterName.CONFIRM_PASSWORD)} className="gap-2.5 self-start px-5 py-2 text-sm font-medium tracking-tighter text-center bg-white rounded-lg border border-solid border-zinc-300 min-h-[34px] whitespace-nowrap my-auto">
            {_t('auth.ChangePassword')}
          </button>}
        </section> : <LoginItem handleClick={()=>{navigate(RouterName.LOGIN+'?loginByMenu=true')}} className="pt-[40px] pb-[40px]" />}
        
        
        <div className="">
          <nav className="flex flex-col text-sm font-medium tracking-tighter text-neutral-900">
            {menuItems.filter(item => item.active).map((item, index) => (
              <CListItemMenu key={index} handleClick={handleClick} dataItem={item} label={item.label} />
            ))}
          </nav>
        </div>
      </div>
      <CDialog
            open={stateDialogLogout}
            closeText={_t('menu.CloseLogout')}
            submitText={_t('menu.OkLogout')}
            handleSubmit={handleLogout}
            closeModal={() => {setStateDialogLogout(false)}}
            classBtn='font-medium'
        >
            <span className="text-[14px] font-medium">{_t('auth.LabelWouldYouWantLogout')}</span>
        </CDialog>
        {stateOpenUpload && <SelectSwiper
          isDrawerOpen={stateOpenUpload}
          type='avatar'
          setIsDrawerOpen={handleChoose}
        />}
      <BottomNavigation onNavigateChange={resetRecipes} activeIndex={5} />
    </AppLayout>
  );
};

export default MenuPage;
